export default "__VITE_ASSET__timUbEj6__"